export default __webpack_public_path__ + "static/media/summary_planimages_109.56409879.png";